import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectiveModule } from 'src/app/extensions/directives/directive.module';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { AboutComponent } from './about.component';
import { AboutRoutingModule } from './about-routing.module';

@NgModule({
  imports: [
    CommonModule,
    AboutRoutingModule,
    FormsModule,
    PipeModule,
    NgbModule,
    TranslateModule.forChild(),
    DirectiveModule,
    ComponentsModule,
  ],
  declarations: [AboutComponent],
  exports: [],
})
export class AboutModule {}
